// extracted by mini-css-extract-plugin
export default {"footerDiv":"Footer_footerDiv__fN2QJ","footerLink":"Footer_footerLink__zoJJ6","footerDivSmall":"Footer_footerDivSmall__nILaE"};